/* eslint-disable import/no-extraneous-dependencies */
import { useEffect, useState } from 'react';
import useFetchData from '../../hooks/useFetchData';
// import notificationWithIcon from '../../utils/notification';
import SundayDonutChart from '../dashboard/SundayDonutChart';
import AttendanceChartBySundaySlots from '../dashboard/AttendanceChartBySundaySlots';
import PresenceByQuartierAreaChart from '../dashboard/PresenceByQuartierAreaChart';

function Index() {
  const [loading, error, response] = useFetchData('/dashboard');
  const [selectedSunday, setSelectedSunday] = useState(null);

  useEffect(() => {
    // notificationWithIcon('error', 'ERROR', `Sorry! Something went wrong. App server error ${JSON.stringify(error)}`);
  }, [error, response]);

  return (
    <div className='px-4 sm:px-6 md:px-10 bg-gray-50'>
      <div className='pt-5'>
        {/* --- Section Charts Principales --- */}
        <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 mb-6'>
          {/* Chart area principal */}
          <div className='panel h-full md:col-span-2'>
            <div className='flex flex-col sm:flex-row items-start sm:items-center justify-between mb-5'>
              <h5 className='font-semibold text-lg mb-2 sm:mb-0'>Revue de tous les dimanches</h5>
            </div>
            <div className='relative'>
              <div className='bg-white rounded-lg overflow-hidden px-2 md:px-5'>
                {loading ? (
                  <div className='min-h-[250px] sm:min-h-[325px] grid place-content-center'>
                    <span className='animate-spin border-2 border-black !border-l-transparent rounded-full w-5 h-5 inline-flex' />
                  </div>
                ) : (
                  <AttendanceChartBySundaySlots
                    sundays={response?.data?.sundaySchedule}
                    onDateClick={(date) => setSelectedSunday(date)}
                  />
                )}
              </div>
            </div>
          </div>

          {/* Donut chart */}
          <div className='panel h-full'>
            <div className='flex flex-col sm:flex-row items-start sm:items-center mb-5'>
              <h5 className='font-semibold text-lg mb-2 sm:mb-0'>Présences par créneau</h5>
            </div>
            <div className='bg-white rounded-lg mx-auto overflow-hidden p-5 md:py-10 min-h-[250px] sm:min-h-[325px]'>
              {loading ? (
                <div className='min-h-[250px] sm:min-h-[325px] grid place-content-center'>
                  <span className='animate-spin border-2 border-black !border-l-transparent rounded-full w-5 h-5 inline-flex' />
                </div>
              ) : (
                <SundayDonutChart
                  sundays={response?.data?.uniqueSundaySchedule}
                  selectedSunday={selectedSunday}
                />
              )}
            </div>
          </div>
        </div>

        {/* --- Section Daily Sales & Summary --- */}
        <div className='grid'>
          {/* Total Orders */}
          <div className='panel h-full p-0'>
            <div className='flex flex-col sm:flex-row items-start sm:items-center justify-between w-full p-5'>
              <h5 className='font-semibold text-lg mb-2 sm:mb-0'>
                Présences par quartier
              </h5>
            </div>
            <div className='bg-white rounded-lg overflow-hidden min-h-[350px] sm:min-h-[490px]'>
              {loading ? (
                <div className='min-h-[250px] sm:min-h-[325px] grid place-content-center'>
                  <span className='animate-spin border-2 border-black !border-l-transparent rounded-full w-5 h-5 inline-flex' />
                </div>
              ) : (
                <PresenceByQuartierAreaChart sundays={response?.data?.sundayScheduleByQuartier} selectedSunday={selectedSunday} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>

  );
}

export default Index;
